module.exports = __webpack_public_path__ + "img/cancelItem.b4d61473.svg";